module.exports = __webpack_public_path__ + "img/color-picker.5331be84.svg";